import { motion } from "framer-motion";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";
import { imgSrc } from "../../lib/api";

export function About({ settings }) {
  return (
    <section id="il-locale" className="relative py-24 sm:py-32" data-testid="about-section">
      <div className="absolute inset-0 spotlight pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <Reveal>
          <div className="relative">
            <div className="absolute -inset-3 border border-gold/25 rounded-2xl translate-x-4 translate-y-4 pointer-events-none" />
            <motion.div
              whileHover={{ scale: 0.985 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="relative overflow-hidden rounded-2xl border border-white/10"
            >
              <img
                src={imgSrc(settings?.about_image)}
                alt="Tavoli e atmosfera conviviale del locale"
                className="w-full aspect-[4/5] sm:aspect-[5/5] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-obsidian/60 via-transparent to-transparent" />
            </motion.div>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <Eyebrow>Il Red Stone</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <SectionTitle className="mt-4">
              Un posto dove <em className="italic text-gold-glow">stare bene</em>
            </SectionTitle>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-base sm:text-lg text-cream-muted font-light leading-relaxed">
              {settings?.about_text}
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-10 grid grid-cols-3 gap-4 border-t border-white/10 pt-8">
              {[
                ["Bar", "Caffetteria, aperitivi e drink"],
                ["Ristopub", "Piatti e burger fatti bene"],
                ["Pizzeria", "Impasti fragranti, forno caldo"],
              ].map(([t, d]) => (
                <div key={t}>
                  <p className="font-serif text-xl text-cream">{t}</p>
                  <p className="mt-1.5 text-xs text-cream-subtle leading-relaxed">{d}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
